import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateViewerControlledVizThemeParams {
    viewerControlledVizTheme: number;
}

export class UpdateViewerControlledVizThemeRequest extends Request<IUpdateViewerControlledVizThemeParams, IResult> {
    constructor(params: IUpdateViewerControlledVizThemeParams) {
        super('updateViewerControlledVizTheme', params);
    }
}
